import { ApiResponse } from '@ace/core';

import { EndpointCallParams } from '@core/api/endpointCallParams';
import { IApiStore } from '@core/api/apiStore';

export type UploadFileParams = {
    id: string;
    file: File;
};

export const performUploadLogo = async (
    api: IApiStore,
    params: EndpointCallParams<UploadFileParams>,
    progressHandler?: (percent: number) => void,
): Promise<ApiResponse> => {
    const { payload, ...rest } = params;
    const { file, id } = payload;

    const req = await api
        .postAFile(
            `identity-app/api/v1/Companies/CompanyLogo/${id}` ,
            {
                ...rest,
                payload,
                progressHandler,
            },
            { fileField: 'logo', file },
            {},
        );

    return req;
}
